import { cn } from '@newfront-insurance/core-ui/v2';
import type { JSX } from 'react';

import { NavigationItem } from './item';
import type { LinkGroup } from '../types';

interface Props {
  group: LinkGroup;
  isShowingDarkSidebar?: boolean;
}

export function NavigationLinkGroup(props: Props): JSX.Element {
  const { group, isShowingDarkSidebar = false } = props;

  return (
    <div className="flex flex-col gap-2">
      {group.title ? (
        <div>
          <div
            data-testid={`group-title-${group.title?.toLowerCase().replace(/ /g, '-')}`}
            className={cn('text-steel-300 pl-2 text-sm leading-5 font-semibold tracking-widest uppercase')}
          >
            {group.title}
          </div>
        </div>
      ) : null}
      <div className="flex flex-col gap-0.5">
        {group.links.map((linkItem) => {
          return (
            <NavigationItem linkItem={linkItem} key={linkItem.label} isShowingDarkSidebar={isShowingDarkSidebar} />
          );
        })}
      </div>
    </div>
  );
}
